import AverageCost from '../bank/averageCost'
import BalanceBreakdownBank from '../bank/balanceBreakdown'
import CapitalAndLeverage from '../bank/capitalAndLeverage'
import CashFlow from '../bank/cashFlow'
import DepositAndCredit from '../bank/depositAndCredit'
import EarningBreakdownBank from '../bank/earningBreakdown'
import EarningQuality from '../bank/earningQuality'
import FundingStructure from '../bank/fundingStructure'
import LiquidityBank from '../bank/liquidity'
import LoanBookBreakdown from '../bank/loanBookBreakdown'
import QuickAssessmentBank from '../bank/quickAssessment'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
} from '../constant'
import AssetManagementEfficiency from '../corporate/assetManagementEfficiency'
import BalanceBreakdown from '../corporate/balanceBreakdown'
import CashBreakdown from '../corporate/cashBreakdown'
import Coverage from '../corporate/coverage'
import EarningBreakdown from '../corporate/earningBreakdown'
import Liquidity from '../corporate/liquidity'
import Profitability from '../corporate/profitability'
import QuickAssessment from '../corporate/quickAssessment'
import RoaAndRoe from '../corporate/roaAndRoe'
import Solvency from '../corporate/solvency'
import BalanceBreakdownLifeInsurance from '../lifeInsurance/balanceBreakdown'
import CashFlowLifeInsurance from '../lifeInsurance/cashFlow'
import EarningBreakdownLifeInsurance from '../lifeInsurance/earningBreakdown'
import InsurancePremiumRevenueLifeInsurance from '../lifeInsurance/insurancePremiumRevenue'
import InsuranceSolvencyLifeInsurance from '../lifeInsurance/insuranceSolvency'
import LiquidityLifeInsurance from '../lifeInsurance/liquidity'
import OperationalEfficiencyLifeInsurance from '../lifeInsurance/operationalEfficiency'
import ProfitabilityLifeInsurance from '../lifeInsurance/profitability'
import RoaAndRoeLifeInsurance from '../lifeInsurance/roaAndRoe'
import AverageCostNonBank from '../nonBank/averageCost'
import BalanceBreakdownNonBank from '../nonBank/balanceBreakdown'
import CapitalAndLeverageNonBank from '../nonBank/capitalAndLeverage'
import CashFlowNonBank from '../nonBank/cashFlow'
import DepositAndCreditNonBank from '../nonBank/depositAndCredit'
import EarningBreakdownNonBank from '../nonBank/earningBreakdown'
import EarningQualityNonBank from '../nonBank/earningQuality'
import FundingStructureNonBank from '../nonBank/fundingStructure'
import LiquidityNonBank from '../nonBank/liquidity'
import LoanBookBreakdownNonBank from '../nonBank/loanBookBreakdown'
import QuickAssessmentNonBank from '../nonBank/quickAssessment'
import BalanceBreakdownNonLifeInsurance from '../nonLifeInsurance/balanceBreakdown'
import CashFlowNonLifeInsurance from '../nonLifeInsurance/cashFlow'
import EarningBreakdownNonLifeInsurance from '../nonLifeInsurance/earningBreakdown'
import InsurancePremiumRevenueNonLifeInsurance from '../nonLifeInsurance/insurancePremiumRevenue'
import InsuranceSolvencyNonLifeInsurance from '../nonLifeInsurance/insuranceSolvency'
import LiquidityNonLifeInsurance from '../nonLifeInsurance/liquidity'
import OperationalEfficiencyNonLifeInsurance from '../nonLifeInsurance/operationalEfficiency'
import ProfitabilityNonLifeInsurance from '../nonLifeInsurance/profitability'
import RoaAndRoeNonLifeInsurance from '../nonLifeInsurance/roaAndRoe'
import BalanceBreakdownSecurity from '../security/balanceBreakdown'
import BusinessPosition from '../security/businessPosition'
import CashFlowSecurity from '../security/cashFlow'
import EarningBreakdownSecurity from '../security/earningBreakdown'
import EarningQualitySecurity from '../security/earningQuality'
import FinancialAsset from '../security/financialAsset'
import FundingAndLiquidity from '../security/fundingAndLiquidity'
import Leverage from '../security/leverage'
import OperatingIncome from '../security/operatingIncome'

const renderComponent = (type, props) => {
  switch (type) {
    // corporate
    case typeComponentCorporate.QUICK_ASSESSMENT:
      return () => <QuickAssessment {...(props || {})} />
    case typeComponentCorporate.PROFITABILITY:
      return () => <Profitability {...(props || {})} />
    case typeComponentCorporate.ROA_AND_ROE:
      return () => <RoaAndRoe {...(props || {})} />
    case typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY:
      return () => <AssetManagementEfficiency {...(props || {})} />
    case typeComponentCorporate.LIQUIDITY:
      return () => <Liquidity {...(props || {})} />
    case typeComponentCorporate.SOLVENCY:
      return () => <Solvency {...(props || {})} />
    case typeComponentCorporate.COVERAGE:
      return () => <Coverage {...(props || {})} />
    case typeComponentCorporate.EARNING_BREAKDOWN:
      return () => <EarningBreakdown {...(props || {})} />
    case typeComponentCorporate.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdown {...(props || {})} />
    case typeComponentCorporate.CASH_BREAKDOWN:
      return () => <CashBreakdown {...(props || {})} />
    // bank
    case typeComponentBank.QUICK_ASSESSMENT:
      return () => <QuickAssessmentBank {...(props || {})} />
    case typeComponentBank.LOAN_BOOK_BREAKDOWN:
      return () => <LoanBookBreakdown {...(props || {})} />
    case typeComponentBank.DEPOSIT_AND_CREDIT:
      return () => <DepositAndCredit {...(props || {})} />
    case typeComponentBank.AVERAGE_COST:
      return () => <AverageCost {...(props || {})} />
    case typeComponentBank.EARNING_QUALITY:
      return () => <EarningQuality {...(props || {})} />
    case typeComponentBank.CAPITAL_AND_LEVERAGE:
      return () => <CapitalAndLeverage {...(props || {})} />
    case typeComponentBank.LIQUIDITY:
      return () => <LiquidityBank {...(props || {})} />
    case typeComponentBank.FUNDING_STRUCTURE:
      return () => <FundingStructure {...(props || {})} />
    case typeComponentBank.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdownBank {...(props || {})} />
    case typeComponentBank.EARNING_BREAKDOWN:
      return () => <EarningBreakdownBank {...(props || {})} />
    case typeComponentBank.CASH_FLOW:
      return () => <CashFlow {...(props || {})} />
    // non bank
    case typeComponentNonBank.QUICK_ASSESSMENT:
      return () => <QuickAssessmentNonBank {...(props || {})} />
    case typeComponentNonBank.LOAN_BOOK_BREAKDOWN:
      return () => <LoanBookBreakdownNonBank {...(props || {})} />
    case typeComponentNonBank.DEPOSIT_AND_CREDIT:
      return () => <DepositAndCreditNonBank {...(props || {})} />
    case typeComponentNonBank.AVERAGE_COST:
      return () => <AverageCostNonBank {...(props || {})} />
    case typeComponentNonBank.EARNING_QUALITY:
      return () => <EarningQualityNonBank {...(props || {})} />
    case typeComponentNonBank.CAPITAL_AND_LEVERAGE:
      return () => <CapitalAndLeverageNonBank {...(props || {})} />
    case typeComponentNonBank.LIQUIDITY:
      return () => <LiquidityNonBank {...(props || {})} />
    case typeComponentNonBank.FUNDING_STRUCTURE:
      return () => <FundingStructureNonBank {...(props || {})} />
    case typeComponentNonBank.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdownNonBank {...(props || {})} />
    case typeComponentNonBank.EARNING_BREAKDOWN:
      return () => <EarningBreakdownNonBank {...(props || {})} />
    case typeComponentNonBank.CASH_FLOW:
      return () => <CashFlowNonBank {...(props || {})} />
    // security
    case typeComponentSecurity.OPERATING_INCOME:
      return () => <OperatingIncome {...(props || {})} />
    case typeComponentSecurity.BUSINESS_POSITION:
      return () => <BusinessPosition {...(props || {})} />
    case typeComponentSecurity.FINANCIAL_ASSET:
      return () => <FinancialAsset {...(props || {})} />
    case typeComponentSecurity.EARNING_QUALITY:
      return () => <EarningQualitySecurity {...(props || {})} />
    case typeComponentSecurity.LEVERAGE:
      return () => <Leverage {...(props || {})} />
    case typeComponentSecurity.FUNDING_AND_LIQUIDITY:
      return () => <FundingAndLiquidity {...(props || {})} />
    case typeComponentSecurity.EARNING_BREAKDOWN:
      return () => <EarningBreakdownSecurity {...(props || {})} />
    case typeComponentSecurity.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdownSecurity {...(props || {})} />
    case typeComponentSecurity.CASH_FLOW:
      return () => <CashFlowSecurity {...(props || {})} />
    // life insurance
    case typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return () => <InsurancePremiumRevenueLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY:
      return () => <OperationalEfficiencyLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.PROFITABILITY:
      return () => <ProfitabilityLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.ROA_AND_ROE:
      return () => <RoaAndRoeLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.INSURANCE_SOLVENCY:
      return () => <InsuranceSolvencyLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.LIQUIDITY:
      return () => <LiquidityLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.EARNING_BREAKDOWN:
      return () => <EarningBreakdownLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdownLifeInsurance {...(props || {})} />
    case typeComponentLifeInsurance.CASH_FLOW:
      return () => <CashFlowLifeInsurance {...(props || {})} />
    // non life insurance
    case typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return () => (
        <InsurancePremiumRevenueNonLifeInsurance {...(props || {})} />
      )
    case typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY:
      return () => <OperationalEfficiencyNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.PROFITABILITY:
      return () => <ProfitabilityNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.ROA_AND_ROE:
      return () => <RoaAndRoeNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.INSURANCE_SOLVENCY:
      return () => <InsuranceSolvencyNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.LIQUIDITY:
      return () => <LiquidityNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.EARNING_BREAKDOWN:
      return () => <EarningBreakdownNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.BALANCE_BREAKDOWN:
      return () => <BalanceBreakdownNonLifeInsurance {...(props || {})} />
    case typeComponentNonLifeInsurance.CASH_FLOW:
      return () => <CashFlowNonLifeInsurance {...(props || {})} />
    default:
      return () => <></>
  }
}

export default renderComponent
